import { HttpContextToken, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';

export const SkipApiInterceptorToken = new HttpContextToken(() => ({
    skipApiInterceptor: true,
}));

export const apiInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (req.context.has(SkipApiInterceptorToken) && req.context.get(SkipApiInterceptorToken).skipApiInterceptor) {
        req = req.clone({
            context: req.context.delete(SkipApiInterceptorToken),
        });
        return next(req);
    }

    const authService = inject(AuthService);
    const configService = inject(ConfigService);
    return combineLatest([authService.getAuthToken(), configService.getAppConfig()]).pipe(
        switchMap(([token, config]) => {
            const newReq = req.clone({
                headers: req.headers
                    .set('Authorization', `Bearer ${token}`)
                    .set('Ocp-Apim-Subscription-Key', config.apimSubscriptionKey),
                url: `${config.apimUri}/${req.url}`,
            });
            return next(newReq);
        }),
    );
};
